import React from 'react';
import PropTypes from 'prop-types';
import { DFPSlotsProvider, AdSlot } from 'react-dfp';
import * as classes from './Advert.module.scss'
import MediaQuery from 'react-responsive';

Advert.propTypes = {
    adData:PropTypes.object,
};

function Advert({adData, column}) {
    return (
        <div className={classes.Advert}>
            <MediaQuery maxWidth={classes.screenMdMax}>
                <DFPSlotsProvider targetingArguments={{ column: column}} dfpNetworkId={`${adData.networkID}`} adUnit={`${adData.adUnit}`}>
                    <div className={classes.Advert__ad_size_wrapper}>
                        <div className={classes.Advert__mpu}>
                            <p className={classes.Advert__title}>advertisement</p>
                            <div className={`MPU__Ads`}>
                            <AdSlot sizes={[ [300, 250] ]} />
                            </div>
                        </div>
                    </div>
                </DFPSlotsProvider>
            </MediaQuery>
            <MediaQuery minWidth={classes.screenMd} maxWidth={classes.screenLgMax}>
                <DFPSlotsProvider targetingArguments={{ column: column}} dfpNetworkId={`${adData.networkID}`} adUnit={`${adData.adUnit}`}>
                    <div className={classes.Advert__ad_size_wrapper}>
                        <div className={classes.Advert__leaderboard}>
                            <p className={classes.Advert__title}>advertisement</p>
                            <div className={`MPU__Ads`}>
                                <AdSlot sizes={[ [728, 90] ]} />
                            </div>
                        </div>
                    </div>
                </DFPSlotsProvider>
            </MediaQuery>
            <MediaQuery minWidth={classes.screenLg}>
                <DFPSlotsProvider targetingArguments={{ column: column}} dfpNetworkId={`${adData.networkID}`} adUnit={`${adData.adUnit}`}>
                    <div className={classes.Advert__ad_size_wrapper}>
                        <div className={classes.Advert__billboard}>
                            <p className={classes.Advert__title}>advertisement</p>
                            <div className={`MPU__Ads`}>
                            <AdSlot sizes={[ [970, 250] ]} />
                            </div>
                        </div>
                    </div>
                </DFPSlotsProvider>
            </MediaQuery>
        </div>
    );
}

export default Advert;